(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["feelits-collection-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('feelits-style-collection')) {
    customElements.define('feelits-style-collection', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.colors = new Set(); this.sizes = new Set(); this.formats = new Set(); this.page = 1;
        this.stockInput = this.querySelector('[data-in-stock]');
        this.colorConfig = JSON.parse(this.querySelector('[data-color-config]').textContent);
        this.pageSize = Number(this.dataset.pageSize) || 24;
        this.grid = this.querySelector('[data-grid]');
        this.rank = JSON.parse(this.querySelector('[data-rank]').textContent);
        this.cards = [...this.querySelectorAll('.fc-product')].map((el, index) => {
          const options = JSON.parse(el.dataset.options);
          return {el,handle:el.dataset.handle,title:el.dataset.title,price:Number(el.dataset.price),created:Number(el.dataset.created),rank:this.dataset.isolatedPreview==='true'?this.rank.indexOf(el.dataset.handle):index,colorIndex:options.findIndex(s=>/^(colou?r|farbe|couleur|colore|kleur|färg|farge|väri|kolor|cor|カラー|색상|颜色)$/i.test(s)),sizeIndex:options.findIndex(s=>/^(size|taille|größe|grosse|talla|taglia|maat|storlek|størrelse|koko|rozmiar|tamanho|サイズ|사이즈|尺码)$/i.test(s)),variants:JSON.parse(el.querySelector('[data-variants]').textContent)};
        });
        this.cards.forEach(card => {
          card.colorMap = JSON.parse(card.el.querySelector('[data-color-map]').textContent);
          card.media = JSON.parse(card.el.querySelector('[data-product-media]').textContent);
          card.variants.forEach(variant => { variant.colors = this.variantColors(card, variant); variant.format = card.colorMap._formats?.[String(variant.id)] || (/\b(?:\d+\s*[- ]?pack|set)\b/i.test(variant.options.join(" ")) ? "set" : "single"); variant.size = card.sizeIndex >= 0 ? this.normalizeSize(variant.options[card.sizeIndex]) : ''; variant.sizes = this.sizeValues(variant.size); });
          card.links = [...card.el.querySelectorAll('a[href]')].filter(a => new URL(a.href).pathname.includes('/products/')).map(a => [a,a.getAttribute('href')]);
          card.images = [...card.el.querySelectorAll('.product-item__primary-image')].map(img => [img,img.hidden]);
          card.priceEl = card.el.querySelector('.price-list');
          card.originalPrice = card.priceEl?.innerHTML;
        });
        this.buildOptions('color'); this.buildOptions('size'); this.buildOptions('format');
        this.restoreState();
        this.setupNavigation();
        const rail = this.querySelector('.fc-rail'), prev = this.querySelector('[data-rail-prev]'), next = this.querySelector('[data-rail-next]');
        if (rail && prev && next) {
        const updateRail = () => {prev.disabled = rail.scrollLeft < 2;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-3;};
        const scrollRail = direction => rail.scrollBy({left:direction*Math.min(528,rail.clientWidth-28),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        prev.addEventListener('click',()=>scrollRail(-1),{signal}); next.addEventListener('click',()=>scrollRail(1),{signal});
        rail.addEventListener('scroll',updateRail,{signal});
        this.observer = new ResizeObserver(updateRail); this.observer.observe(rail);
        const current=rail.querySelector('[aria-current="page"]');
        if(current)rail.scrollLeft=Math.max(0,current.offsetLeft-rail.offsetLeft-18);
        updateRail();
        }
        this.querySelector('[data-sort]').addEventListener('change',()=>{this.page=1;this.update();},{signal});
        this.querySelector('[data-in-stock]').addEventListener('change',()=>{this.page=1;this.update();},{signal});
        this.querySelector('[data-reset]').addEventListener('click',()=>this.reset(),{signal});
        this.querySelector('[data-clear-filters]').addEventListener('click',()=>this.reset(),{signal});
        this.querySelector('[data-page-prev]').addEventListener('click',()=>this.goPage(this.page-1),{signal});
        this.querySelector('[data-page-next]').addEventListener('click',()=>this.goPage(this.page+1),{signal});
        this.querySelectorAll('.fc-filter').forEach(details=>details.addEventListener('toggle',()=>{if(details.open)this.querySelectorAll('.fc-filter').forEach(other=>{if(other!==details)other.open=false;});},{signal}));
        document.addEventListener('click',e=>{if(!e.target.closest('.fc-filter'))this.querySelectorAll('.fc-filter').forEach(d=>d.open=false);},{signal});
        this.addEventListener('keydown',e=>{if(e.key==='Escape')this.querySelectorAll('.fc-filter').forEach(d=>{if(d.open){d.open=false;d.querySelector('summary').focus();}});},{signal});
        this.update();
      }
      disconnectedCallback(){this.abort?.abort();this.navigationAbort?.abort();this.observer?.disconnect();this.initialized=false;}
      normalizeColor(value) {
        return String(value || '').normalize('NFKC').trim().toLowerCase().replace(/\s+/g, ' ');
      }
      variantColors(card, variant) {
        const reviewed = card.colorMap[String(variant.id)];
        if (reviewed) return reviewed;
        if (/leopard|stripe|polka|hearts|bubble dots/i.test(variant.options.join(' '))) return ['prints'];
        const raw = card.colorIndex >= 0 ? this.normalizeColor(variant.options[card.colorIndex]) : '';
        return this.colorConfig.aliases[raw] || ['other'];
      }
      optionLabel(kind, value) {
        return this.moneyText(kind === 'color' ? (this.colorConfig.labels[value] || value) : kind === 'format' ? this.colorConfig.formatLabels[value] : value);
      }
      buildOptions(kind) {
        const values = new Set();
        for (const card of this.cards) {
          if (kind === 'color') card.variants.forEach(v => v.colors.forEach(value => values.add(value)));
          else if (kind === 'format') card.variants.forEach(v => values.add(v.format));
          else if (card.sizeIndex >= 0) card.variants.forEach(v => v.sizes.forEach(value => values.add(value)));
        }
        const sizes = ['XXS','XS','S','M','L','XL','XXL','XXXL','4XL','5XL','One size'];
        const sorted = kind === 'color'
          ? this.colorConfig.order.filter(value => values.has(value))
          : kind === 'format' ? ['single','set'].filter(v=>values.has(v)) : [...values].sort((a,b) => {
            const ai=sizes.indexOf(a),bi=sizes.indexOf(b);
            if(ai>=0 || bi>=0)return (ai<0?100:ai)-(bi<0?100:bi);
            return a.localeCompare(b,undefined,{numeric:true});
          });
        const details = this.querySelector('[data-filter="'+kind+'"]');
        details.hidden = !sorted.length || (kind === 'format' && !values.has('set'));
        const container = this.querySelector('[data-options="'+kind+'"]');
        container.replaceChildren();
        if (kind !== 'size') { container.setAttribute('role','radiogroup'); container.setAttribute('aria-label',details.querySelector('summary').textContent.trim()); }
        sorted.forEach(value => {
          const label = document.createElement('label');
          const check = document.createElement('input');
          const name = document.createElement('span');
          const count = document.createElement('span');
          check.type = kind !== 'size' ? 'radio' : 'checkbox'; check.value = value; check.dataset.kind = kind;
          if (kind !== 'size') check.name = 'fc-' + kind + '-' + this.dataset.sectionId;
          label.className = 'fc-option'; label.dataset.wide = String(kind === 'size' && value.length > 9);
          name.className = 'fc-option-name'; name.textContent = this.optionLabel(kind,value);
          count.className = 'fc-option-count'; count.setAttribute('aria-hidden','true');
          label.append(check);
          if (kind === 'color') {
            const swatch = document.createElement('span');
            swatch.className = 'fc-color-swatch';
            swatch.dataset.color = value;
            swatch.style.setProperty('--fc-swatch', this.colorConfig.swatches[value]);
            swatch.setAttribute('aria-hidden','true');
            label.append(swatch);
          }
          label.append(name,count);
          check.addEventListener('change', () => {
            const set = this[kind === 'color' ? 'colors' : kind === 'format' ? 'formats' : 'sizes'];
            if (kind !== 'size') set.clear();
            check.checked ? set.add(value) : set.delete(value);
            this.page = 1; this.update();
          }, {signal:this.abort.signal});
          container.append(label);
        });
      }
      matches(card, colors = this.colors, sizes = this.sizes, formats = this.formats) {
        const stock = this.stockInput.checked;
        return card.variants.some(v => (!stock || v.available)
          && (!formats.size || formats.has(v.format))
          && (!colors.size || v.colors.some(color => colors.has(color)))
          && (!sizes.size || card.sizeIndex >= 0 && v.sizes.some(size => sizes.has(size))));
      }
      updateOptionStates() {
        this.querySelectorAll('.fc-options input[data-kind]').forEach(input => {
          const kind = input.dataset.kind, value = input.value;
          const selected = this[kind === 'color' ? 'colors' : kind === 'format' ? 'formats' : 'sizes'].has(value);
          const colors = kind === 'color' ? new Set([value]) : this.colors;
          const sizes = kind === 'size' ? new Set([value]) : this.sizes;
          const count = this.cards.filter(card => this.matches(card, colors, sizes, kind === 'format' ? new Set([value]) : this.formats)).length;
          input.checked = selected;
          input.disabled = count === 0 && !selected;
          const label = input.closest('label');
          label.dataset.empty = String(count === 0);
          label.querySelector('.fc-option-count').textContent = '(' + count + ')';
          input.setAttribute('aria-label', this.optionLabel(kind,value) + ', ' + this.colorConfig.countLabel.replace('__COUNT__',String(count)));
        });
        this.querySelectorAll('.fc-filter').forEach(details => {
          const selected = this[details.dataset.filter === 'color' ? 'colors' : details.dataset.filter === 'format' ? 'formats' : 'sizes'].size;
          let badge = details.querySelector('.fc-selected-count');
          if (!badge) {
            badge = document.createElement('span'); badge.className = 'fc-selected-count';
            details.querySelector('summary').append(badge);
          }
          badge.hidden = selected === 0; badge.textContent = '(' + selected + ')';
        });
        const clear = this.querySelector('[data-clear-filters]');
        clear.hidden = !this.colors.size && !this.sizes.size && !this.formats.size && !this.stockInput.checked;
      }


      normalizeSize(value) {
        const size=String(value || '').normalize('NFKC').trim().toUpperCase().replace(/\s+/g,' ');
        const pantySize=size.match(/^([LM])\s*[-–—]?\s*FOR\b/);
        if(pantySize)return pantySize[1];
        return ({'2XL':'XXL','3XL':'XXXL','2XS':'XXS','ONE SIZE':'One size','ONESIZE':'One size','ONE-SIZE':'One size','FREE SIZE':'One size','F':'One size','SMALL-MEDIUM':'S–M','LARGE-X-LARGE':'L–XL'})[size] || size;
      }
      sizeValues(value) {
        const size=this.normalizeSize(value);
        if(/\b(?:PACK|SET)\b/.test(size))return [];
        const combined=size.replace(/\s*[–—/-]\s*/g,'-');
        if(combined==='S-M')return ['S','M'];
        if(combined==='L-XL')return ['L','XL'];
        return size ? [size] : [];
      }
      chooseVariant(card) {
        const stock=this.stockInput.checked;
        const matches=card.variants.filter(v=>(!stock||v.available)&&(!this.formats.size||this.formats.has(v.format))&&(!this.colors.size||v.colors.some(c=>this.colors.has(c)))&&(!this.sizes.size||v.sizes.some(size => this.sizes.has(size))));
        return matches.find(v=>v.available&&v.mediaId) || matches.find(v=>v.available) || matches.find(v=>v.mediaId) || matches[0];
      }
      displayVariant(card) {
        const active=Boolean(this.colors.size||this.sizes.size||this.formats.size),variant=card.match;
        const caption=card.el.querySelector('[data-variant-caption]'),detail=card.el.querySelector('[data-variant-link]');
        card.el.dataset.variantFiltered=String(active);
        caption.hidden=detail.hidden=!active;
        const swatches=[...card.el.querySelectorAll('.product-item-meta__swatch-list .color-swatch')];
        swatches.forEach(s=>{const radio=s.querySelector('input');const selected=radio&&variant?.options.includes(radio.value);s.hidden=active&&Boolean(radio)&&!selected&&variant?.format!=='set';if(radio){radio.disabled=active;if(active)radio.checked=Boolean(selected);}});
        if(!active){
          if(card.displayedVariant){
            card.links.forEach(([link,href])=>link.setAttribute('href',href));
            card.el.querySelectorAll('.product-item__primary-image').forEach(img=>img.hidden=true);
            card.images.forEach(([img,hidden])=>img.hidden=hidden);
            if(card.priceEl)card.priceEl.innerHTML=card.originalPrice;
            card.displayedVariant=null;
          }
          return;
        }
        const displayKey=variant&&[variant.id,...this.colors,...this.sizes,...this.formats].join('|');
        if(!variant || card.displayedVariant===displayKey)return;
        card.displayedVariant=displayKey;
        const color=card.colorIndex>=0?variant.options[card.colorIndex]:this.optionLabel('color',variant.colors.find(c=>this.colors.has(c))||variant.colors[0]);
        caption.textContent=[color,this.formats.size?this.optionLabel('format',variant.format):null,this.sizes.size?variant.options[card.sizeIndex]:null,!variant.available?card.el.dataset.soldOut:null].filter(Boolean).join(' · ');
        card.links.forEach(([link,href])=>{const url=new URL(href,location.href);url.searchParams.set('variant',variant.id);link.setAttribute('href',url.pathname+url.search+url.hash);});
        const original=card.links[0]?.[1];
        if(original){const url=new URL(original,location.href);url.searchParams.set('variant',variant.id);detail.href=url.pathname+url.search;}
        let mediaId=variant.mediaId;
        if(!mediaId&&card.colorIndex>=0){
          mediaId=card.variants.find(v=>v.mediaId&&v.options[card.colorIndex]===variant.options[card.colorIndex])?.mediaId;
        }
        let image=mediaId?card.el.querySelector('.product-item__primary-image[data-media-id="'+mediaId+'"]'):null;
        if(!image&&mediaId){
          const media=card.media.find(m=>m.id===mediaId);
          if(media){
            image=document.createElement('img');image.className='product-item__primary-image';image.dataset.mediaId=String(mediaId);
            image.src=media.src;image.width=media.width;image.height=media.height;image.loading='lazy';image.alt=card.title+' — '+color;
            card.el.querySelector('.product-item__aspect-ratio').append(image);
          }
        }
        if(image){
          card.el.querySelectorAll('.product-item__primary-image').forEach(img=>img.hidden=img!==image);
        }else{
          card.el.querySelectorAll('.product-item__primary-image').forEach(img=>img.hidden=true);
          card.images.forEach(([img,hidden])=>img.hidden=hidden);
        }
        if(card.priceEl){
          const price=document.createElement('span');price.className=variant.comparePrice>variant.price?'price price--highlight':'price';
          price.textContent=this.moneyText(variant.priceLabel);card.priceEl.replaceChildren(price);
          if(variant.comparePrice>variant.price){const compare=document.createElement('span');compare.className='price price--compare';compare.textContent=this.moneyText(variant.compareLabel);card.priceEl.append(compare);}
        }
      }
      moneyText(value){return new DOMParser().parseFromString(String(value),'text/html').body.textContent;}
      restoreState() {
        const params=new URL(location.href).searchParams;
        this.colors=new Set(params.getAll('fc_color').map(c=>c==='multicolor'?'prints':c).filter(c=>this.colorConfig.order.includes(c)).slice(0,1));
        this.formats=new Set(params.getAll('fc_format').filter(v=>['single','set'].includes(v)).slice(0,1));
        this.sizes=new Set(params.getAll('fc_size').flatMap(s=>this.sizeValues(s)));
        this.page=Math.max(1,Number(params.get('fc_page'))||1);
        this.querySelector('[data-in-stock]').checked=params.get('fc_stock')==='1';
        const sort=this.querySelector('[data-sort]');
        sort.value=[...sort.options].some(o=>o.value===params.get('fc_sort'))?params.get('fc_sort'):'best';
      }
      stateURL(href) {
        const url=new URL(href,location.href);
        for(const name of ['fc_color','fc_size','fc_format','fc_stock','fc_sort','fc_page'])url.searchParams.delete(name);
        this.colors.forEach(value=>url.searchParams.append('fc_color',value));
        this.sizes.forEach(value=>url.searchParams.append('fc_size',value));
        this.formats.forEach(value=>url.searchParams.append('fc_format',value));
        if(this.querySelector('[data-in-stock]').checked)url.searchParams.set('fc_stock','1');
        this.updateOptionStates();
        const sort=this.querySelector('[data-sort]').value;
        if(sort!=='best')url.searchParams.set('fc_sort',sort);
        if(url.pathname===location.pathname&&this.page>1)url.searchParams.set('fc_page',this.page);
        return url;
      }
      saveState() {
        if(window.Shopify?.designMode)return;
        const url=this.stateURL(location.href);
        history.replaceState({...history.state,feelitsCollection:true},'',url);
      }
      categoryURL(link) {
        const url=new URL(link.href,location.href);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');
        if(preview)url.searchParams.set('preview_theme_id',preview);
        else if(this.dataset.themeRole!=='main'&&this.dataset.themeRole!=='MAIN')url.searchParams.set('preview_theme_id',this.dataset.themeId);
        return url;
      }
      setupNavigation() {
        if(window.Shopify?.designMode)return;
        const signal=this.abort.signal;
        this.querySelectorAll('.fc-category,.fc-all-products').forEach(link=>link.href=this.categoryURL(link));
        this.addEventListener('click',event=>{
          const link=event.target.closest('.fc-category,.fc-all-products');
          if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.target==='_blank')return;
          const url=this.categoryURL(link);
          if(url.origin!==location.origin)return;
          event.preventDefault();event.stopPropagation();
          if(link.getAttribute('aria-current')==='page')return;
          this.navigate(this.stateURL(url),false,link);
        },{capture:true,signal});
        let prefetchTimer;
        const prefetch=event=>{
          const link=event.target.closest('.fc-category,.fc-all-products');
          if(!link||link.getAttribute('aria-current')==='page'||navigator.connection?.saveData)return;
          clearTimeout(prefetchTimer);
          prefetchTimer=setTimeout(()=>{if(this.isConnected)this.fetchPage(this.categoryURL(link)).catch(()=>{});},100);
        };
        this.addEventListener('pointerover',prefetch,{signal});
        this.addEventListener('focusin',prefetch,{signal});
        window.addEventListener('popstate',()=>{
          if(this.loadedPath===this.pageKey(location.href)){
            this.restoreState();this.update();
          }else this.navigate(new URL(location.href),true);
        },{signal});
        this.loadedPath=this.pageKey(location.href);
      }
      pageKey(href){const url=new URL(href,location.href);['fc_color','fc_size','fc_format','fc_stock','fc_sort','fc_page'].forEach(name=>url.searchParams.delete(name));return url.pathname+url.search;}
      async fetchPage(url) {
        const target=new URL(url);
        ['fc_color','fc_size','fc_format','fc_stock','fc_sort','fc_page'].forEach(name=>target.searchParams.delete(name));
        const cache=this.constructor.pageCache ||= new Map();
        const key=target.href;
        const cached=cache.get(key);
        if(cached&&Date.now()-cached.time<30000)return cached.promise;
        const promise=fetch(key,{credentials:'same-origin',signal:AbortSignal.timeout(15000),headers:{'X-Requested-With':'XMLHttpRequest'}}).then(response=>{
          if(!response.ok)throw Error('Collection request failed');
          return response.text();
        }).then(html=>{
          if(!html.includes('<feelits-style-collection'))throw Error('Collection not supported');
          return html;
        }).catch(error=>{cache.delete(key);throw error;});
        cache.set(key,{promise,time:Date.now()});
        while(cache.size>4)cache.delete(cache.keys().next().value);
        return promise;
      }
      async navigate(url,back=false,link=null) {
        const token=(this.navigationToken||0)+1;this.navigationToken=token;
        this.querySelectorAll('.fc-category[data-loading]').forEach(a=>a.removeAttribute('data-loading'));
        if(link)link.dataset.loading='true';
        this.setAttribute('aria-busy','true');
        try{
          const html=await this.fetchPage(url);
          if(token!==this.navigationToken||!this.isConnected)return;
          const parsed=new DOMParser().parseFromString(html,'text/html');
          const incoming=parsed.querySelector('feelits-style-collection');
          if(!incoming||incoming.dataset.themeId!==this.dataset.themeId)throw Error('Theme mismatch');
          const wrapper=incoming.closest('.shopify-section');
          const currentWrapper=this.closest('.shopify-section');
          if(!wrapper||!currentWrapper)throw Error('Collection section missing');
          const images=[...incoming.querySelectorAll('.fc-category img'),...incoming.querySelectorAll('.fc-product .product-item__primary-image:not([hidden])')].slice(0,12);
          await Promise.race([Promise.all(images.map(img=>{const preload=new Image();preload.src=img.currentSrc||img.src;return preload.decode().catch(()=>{});})),new Promise(resolve=>setTimeout(resolve,500))]);
          if(token!==this.navigationToken||!this.isConnected)return;
          const railLeft=this.querySelector('.fc-rail').scrollLeft;
          const top=this.getBoundingClientRect().top+scrollY;
          if(!back)history.pushState({feelitsCollection:true},'',url);
          document.title=parsed.title;
          for(const selector of ['link[rel="canonical"]','meta[name="description"]','meta[property="og:url"]','meta[property="og:title"]','meta[property="og:description"]']){
            const old=document.head.querySelector(selector),fresh=parsed.head.querySelector(selector);
            if(old&&fresh)old.replaceWith(document.importNode(fresh,true));
          }
          const freshHreflangs=parsed.head.querySelectorAll('link[rel~="alternate"][hreflang]');
          if(freshHreflangs.length){
            document.head.querySelectorAll('link[rel~="alternate"][hreflang]').forEach(node=>node.remove());
            freshHreflangs.forEach(node=>document.head.appendChild(document.importNode(node,true)));
          }
          const replacement=document.importNode(wrapper,true);
          currentWrapper.replaceWith(replacement);
          const next=replacement.querySelector('feelits-style-collection');
          const rail=next.querySelector('.fc-rail');rail.scrollLeft=railLeft;
          const active=rail.querySelector('[aria-current="page"]');
          if(active&&(active.getBoundingClientRect().left<rail.getBoundingClientRect().left||active.getBoundingClientRect().right>rail.getBoundingClientRect().right))rail.scrollLeft=active.offsetLeft-rail.offsetLeft-18;
          next.querySelector('.fc-heading h1').focus({preventScroll:true});
          if(!back&&scrollY>top)window.scrollTo({top:Math.max(0,top-100),behavior:'instant'});
          document.dispatchEvent(new CustomEvent('feelits:collection:changed',{detail:{url:url.href,title:document.title}}));
        }catch(error){
          if(token!==this.navigationToken||!this.isConnected)return;
          location.assign(url.href);
        }finally{
          if(token===this.navigationToken){this.removeAttribute('aria-busy');link?.removeAttribute('data-loading');}
        }
      }

      prioritizeVisibleImages(visible) {
        const current=new Map();
        let position=0;
        for(const card of visible){
          if(position>=2)break;
          const priority=position++===0?'high':'auto';
          const image=card.el.querySelector('.product-item__primary-image:not([hidden])');
          if(image)current.set(image,priority);
        }
        const managed=this.priorityImages||new Map();
        for(const [image,original] of managed){
          if(current.has(image))continue;
          for(const [attribute,value] of original){
            if(value===null){if(image.hasAttribute(attribute))image.removeAttribute(attribute);}
            else if(image.getAttribute(attribute)!==value)image.setAttribute(attribute,value);
          }
          managed.delete(image);
        }
        for(const [image,priority] of current){
          if(!managed.has(image))managed.set(image,['loading','fetchpriority'].map(attribute=>[attribute,image.getAttribute(attribute)]));
          if(image.getAttribute('loading')!=='eager')image.setAttribute('loading','eager');
          if(image.getAttribute('fetchpriority')!==priority)image.setAttribute('fetchpriority',priority);
        }
        this.priorityImages=managed;
      }

      update() {
        const sort=this.querySelector('[data-sort]').value;
        this.filtered=this.cards.filter(c=>this.matches(c));
        this.filtered.forEach(card => { card.match = this.chooseVariant(card); card.sortPrice = card.match && (this.colors.size || this.sizes.size || this.formats.size) ? card.match.price : card.price; });
        this.filtered.sort((a,b)=>sort==='price-asc'?a.sortPrice-b.sortPrice:sort==='price-desc'?b.sortPrice-a.sortPrice:sort==='newest'?b.created-a.created:sort==='title'?a.title.localeCompare(b.title):a.rank-b.rank);
        this.pages=Math.max(1,Math.ceil(this.filtered.length/this.pageSize));this.page=Math.min(this.page,this.pages);
        const visible = new Set(this.filtered.slice((this.page-1)*this.pageSize,this.page*this.pageSize));
        this.cards.forEach(c=>{const hide=!visible.has(c);if(c.el.hidden!==hide)c.el.hidden=hide;});
        const order = [...this.filtered,...this.cards.filter(c=>!this.filtered.includes(c))];
        order.forEach((c,i)=>{if(this.grid.children[i]!==c.el)this.grid.insertBefore(c.el,this.grid.children[i]||null);});
        visible.forEach(c=>this.displayVariant(c));
        this.prioritizeVisibleImages(visible);
        this.querySelector('[data-count]').textContent=this.dataset.countLabel.replace('__COUNT__',String(this.filtered.length));
        this.querySelector('[data-empty]').hidden=this.filtered.length>0;
        this.querySelector('[data-pagination]').hidden=this.pages<=1;
        this.querySelector('[data-page-prev]').disabled=this.page<=1;
        this.querySelector('[data-page-next]').disabled=this.page>=this.pages;
        const numbers=this.querySelector('[data-page-numbers]');numbers.replaceChildren();
        for(let n=1;n<=this.pages;n++){const button=document.createElement('button');button.type='button';button.textContent=String(n);button.setAttribute('aria-label',this.dataset.pageLabel.replace('__PAGE__',String(n)));if(n===this.page)button.setAttribute('aria-current','page');button.addEventListener('click',()=>this.goPage(n));numbers.append(button);}
        this.renderActive();
        this.dataset.ready='true';
        this.saveState();
      }
      renderActive() {
        const target=this.querySelector('[data-active-filters]');target.replaceChildren();
        for(const [kind,set] of [['color',this.colors],['size',this.sizes],['format',this.formats]])for(const value of set){const button=document.createElement('button');button.type='button';button.textContent=this.optionLabel(kind,value)+' ×';button.setAttribute('aria-label',this.dataset.removeLabel+': '+this.optionLabel(kind,value));button.addEventListener('click',()=>{set.delete(value);this.querySelectorAll('input[data-kind="'+kind+'"]').forEach(i=>{if(i.value===value)i.checked=false;});this.page=1;this.update();});target.append(button);}
      }
      reset(){this.colors.clear();this.sizes.clear();this.formats.clear();this.querySelectorAll('.fc-options input,[data-in-stock]').forEach(i=>i.checked=false);this.page=1;this.update();}
      goPage(n){this.page=Math.max(1,Math.min(this.pages,n));this.update();this.querySelector('.fc-controls').scrollIntoView({block:'start',behavior:'instant'});}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["feelits-free-shipping-assets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('feelits-free-shipping')) {
    customElements.define('feelits-free-shipping', class extends HTMLElement {
      constructor() {
        super();
        this.onCartUpdated = this.onCartUpdated.bind(this);
        this.render = this.render.bind(this);
      }

      connectedCallback() {
        this.shippingRequired = true;
        this.render();
        document.documentElement.addEventListener('cart:updated', this.onCartUpdated);
        window.addEventListener('pageshow', this.render);
      }

      disconnectedCallback() {
        document.documentElement.removeEventListener('cart:updated', this.onCartUpdated);
        window.removeEventListener('pageshow', this.render);
      }

      onCartUpdated(event) {
        const cart = event.detail?.cart;
        if (!cart || !Number.isFinite(cart.total_price) || !cart.currency) {
          this.hidden = true;
          return;
        }
        this.dataset.total = String(cart.total_price);
        this.dataset.currency = cart.currency;
        this.shippingRequired = Array.isArray(cart.items) && cart.items.some(item => item.requires_shipping);
        this.render();
      }

      render() {
        const amount = Number(this.dataset.baseAmount);
        const total = Number(this.dataset.total);
        const currency = this.dataset.currency;
        const baseCurrency = this.dataset.baseCurrency;
        const storefrontCurrency = window.Shopify?.currency;
        let rate = 1;

        if (currency !== baseCurrency) {
          if (storefrontCurrency?.active !== currency) {
            this.hidden = true;
            return;
          }
          rate = Number(storefrontCurrency.rate);
        }

        if (!this.shippingRequired || !Number.isFinite(amount) || amount <= 0 || !Number.isFinite(rate) || rate <= 0 || !Number.isFinite(total) || total < 0) {
          this.hidden = true;
          return;
        }

        try {
          const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency', currency, currencyDisplay: 'symbol'
          });
          const digits = formatter.resolvedOptions().maximumFractionDigits;
          const quantum = 100 / (10 ** digits);
          const threshold = Math.ceil((amount * 100 * rate) / quantum - 1e-9) * quantum;
          if (!Number.isFinite(threshold) || threshold <= 0) {
            this.hidden = true;
            return;
          }
          const remaining = Math.max(0, threshold - total);
          const displayedRemaining = Math.ceil(remaining / quantum - 1e-9) * quantum;

          this.querySelector('[data-message]').textContent = remaining > 0
            ? this.dataset.remaining.replace('__amount__', formatter.format(displayedRemaining / 100))
            : this.dataset.reached;
          this.hidden = false;
        } catch {
          this.hidden = true;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["feelits-pdp-progress"] && !Shopify.designMode) return;
  try {
    (() => {
    const tag = 'feelits-pdp-savings';
    if (customElements.get(tag)) return;

    class FeelitsPdpSavings extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.version = 0;
        const options = { signal: this.events.signal };
        for (const name of ['cart:updated', 'cart:refresh', 'cart:change']) {
          document.addEventListener(name, event => {
            const quantity = this.getQuantity(event.detail?.cart);
            if (quantity === null) {
              this.queueRefresh();
              return;
            }
            this.cancelRefresh();
            this.render(quantity);
          }, options);
        }
        document.addEventListener('variant:added', () => this.queueRefresh(), options);
        window.addEventListener('pageshow', event => {
          if (event.persisted) this.queueRefresh();
        }, options);
        window.addEventListener('focus', () => this.queueRefresh(), options);
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') this.queueRefresh();
        }, options);
        this.queueRefresh();
      }

      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
        this.cancelRefresh();
      }

      getQuantity(cart) {
        if (!Array.isArray(cart?.items) || !Number.isInteger(cart.item_count)) return null;
        let quantity = 0;
        for (const item of cart.items) {
          if (!Number.isInteger(item.quantity) || item.quantity < 0 ||
              typeof item.final_line_price !== 'number' || !Number.isFinite(item.final_line_price)) return null;
          if (Number(item.product_id) === 15398861799574 || item.sku === 'AC05GRY') continue;
          if (!item.gift_card && item.final_line_price > 0) quantity += item.quantity;
        }
        return quantity;
      }

      render(quantity) {
        const title = this.querySelector('.fpdp-title');
        if (!title) return;
        let message = this.dataset.title;
        if (quantity !== null) {
          if (quantity >= 5) {
            message = this.dataset.unlocked;
          } else {
            const target = quantity < 2 ? 2 : quantity < 3 ? 3 : 5;
            const percent = target === 2 ? 5 : target === 3 ? 8 : 10;
            const remaining = target - quantity;
            message = (remaining === 1 ? this.dataset.addOne : this.dataset.addMany).replace('@count@', remaining).replace('@percent@', percent);
          }
        }
        if (title.textContent !== message) title.textContent = message;
        this.querySelectorAll('[data-reached-at]').forEach(node => {
          node.classList.toggle('is-reached', quantity !== null && quantity >= Number(node.dataset.reachedAt));
        });
      }

      cancelRefresh() {
        this.version += 1;
        clearTimeout(this.refreshTimer);
        this.request?.abort();
      }

      queueRefresh() {
        this.cancelRefresh();
        const version = this.version;
        this.refreshTimer = setTimeout(() => this.refresh(version), 180);
      }

      async refresh(version) {
        if (!this.isConnected || version !== this.version) return;
        const controller = new AbortController();
        this.request = controller;
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          const root = window.Shopify?.routes?.root || '/';
          const url = new URL(root + 'cart.js', window.location.origin);
          if (url.origin !== window.location.origin) throw new Error('Invalid cart URL');
          const response = await fetch(url.href, {
            method: 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller.signal
          });
          if (!response.ok) throw new Error('Cart unavailable');
          const quantity = this.getQuantity(await response.json());
          if (quantity === null) throw new Error('Invalid cart');
          if (this.isConnected && version === this.version) this.render(quantity);
        } catch {
          if (this.isConnected && version === this.version) this.render(null);
        } finally {
          clearTimeout(timeout);
          if (this.request === controller) this.request = null;
        }
      }
    }

    customElements.define(tag, FeelitsPdpSavings);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["feelits-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('feelits-product-video')) {
    customElements.define('feelits-product-video', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.trigger = this.querySelector('.feelits-product-video__cover');
        this.dialog = this.querySelector('dialog');
        this.player = this.querySelector('.feelits-product-video__player');
        this.inlinePlayer = this.querySelector('.feelits-product-video__inline');
        if (!this.trigger || !this.dialog || !this.player || !this.inlinePlayer) return;
        this.desktopMedia = window.matchMedia('(min-width: 1000px)');
        this.updateTrigger();
        this.desktopMedia.addEventListener('change', () => {
          this.pause();
          this.updateTrigger();
        }, options);
        // Native video controls must not start a Flickity drag, especially in the mobile dialog.
        for (const target of [this.inlinePlayer, this.dialog]) {
          for (const type of ['pointerdown', 'touchstart', 'mousedown']) {
            target.addEventListener(type, event => event.stopPropagation(), options);
          }
        }
        this.trigger.addEventListener('pointerdown', event => {
          this.pointerStart = { x: event.clientX, y: event.clientY };
          this.dragged = false;
        }, options);
        this.trigger.addEventListener('pointermove', event => {
          if (this.pointerStart && Math.hypot(event.clientX - this.pointerStart.x, event.clientY - this.pointerStart.y) > 10) this.dragged = true;
        }, options);
        this.trigger.addEventListener('pointercancel', () => { this.dragged = true; }, options);
        this.trigger.addEventListener('click', event => {
          event.stopPropagation();
          if (event.detail !== 0 && this.dragged) return;
          this.open();
        }, options);
        this.querySelector('.feelits-product-video__close').addEventListener('click', () => this.pause(), options);
        this.dialog.addEventListener('close', () => {
          if (!this.dialog.open && !this.inlineActive) this.reset();
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog || event.target === this.player) this.pause();
        }, options);
      }
      updateTrigger() {
        if (this.desktopMedia.matches) {
          this.trigger.removeAttribute('aria-haspopup');
          this.trigger.setAttribute('aria-controls', this.inlinePlayer.id);
        } else {
          this.trigger.setAttribute('aria-haspopup', 'dialog');
          this.trigger.setAttribute('aria-controls', this.dialog.id);
        }
      }
      open() {
        if (this.dialog.open || this.inlineActive) return;
        document.querySelectorAll('feelits-product-video').forEach(item => {
          if (item !== this) item.pause();
        });
        const desktop = this.desktopMedia.matches;
        const target = desktop ? this.inlinePlayer : this.player;
        const template = this.querySelector('template');
        const templateVideo = template.content.querySelector('video');
        let mobileSources = [];
        if (!desktop && templateVideo) {
          try {
            const sources = JSON.parse(this.getAttribute('data-feelits-mp4-sources') || '[]');
            if (Array.isArray(sources)) mobileSources = sources.filter(source => source && typeof source.url === 'string' && source.url);
          } catch (error) {
            // Keep the original template path when a source list is unavailable.
          }
          if (!mobileSources.length) {
            mobileSources = Array.from(templateVideo.querySelectorAll('source')).filter(source => source.type === 'video/mp4').map(source => ({ url: source.src, height: 0 }));
          }
          mobileSources.sort((a, b) => (Number(b.height) || 0) - (Number(a.height) || 0));
          mobileSources = mobileSources.filter((source, index, sources) => sources.findIndex(item => item.url === source.url) === index);
        }
        if (mobileSources.length) {
          // Create a fresh media element in this document rather than cloning an inert template player.
          const video = document.createElement('video');
          for (const attribute of templateVideo.attributes) video.setAttribute(attribute.name, attribute.value);
          for (const image of templateVideo.querySelectorAll('img')) video.appendChild(image.cloneNode(true));
          video.preload = 'metadata';
          video.setAttribute('loading', 'eager');
          target.replaceChildren(video);
        } else {
          target.replaceChildren(template.content.cloneNode(true));
        }
        if (desktop) {
          this.inlineActive = true;
          this.trigger.hidden = true;
          this.inlinePlayer.hidden = false;

        } else {
          this.dialog.showModal();
          document.documentElement.classList.add('feelits-video-open');
        }
        this.playbackActive = true;
        this.dispatchEvent(new CustomEvent('video:played', { bubbles: true }));
        this.trigger.setAttribute('aria-expanded', 'true');
        const video = target.querySelector('video');
        if (video && mobileSources.length) this._startMobileVideo(video, mobileSources);
        else if (video) video.play().catch(() => {});
      }
      _startMobileVideo(video, sources) {
        this._clearMobileStartup();
        const state = this.mobilePlayback = {
          video, sources, index: -1, attempt: 0, timer: null,
          controller: new AbortController(), frameReady: false,
          userPaused: false, permissionBlocked: false, exhausted: false,
          resumeTime: 0
        };
        const options = { signal: state.controller.signal };
        const current = () => this.mobilePlayback === state && this.playbackActive && !state.controller.signal.aborted;
        const clearWatchdog = () => {
          if (state.timer !== null) clearTimeout(state.timer);
          state.timer = null;
        };
        const stopStartup = () => {
          if (!current()) return;
          state.frameReady = true;
          clearWatchdog();
        };
        const watchStartup = attempt => {
          clearWatchdog();
          if (!current() || state.frameReady || state.userPaused || state.permissionBlocked || state.exhausted) return;
          state.timer = setTimeout(() => {
            state.timer = null;
            if (!current() || attempt !== state.attempt || state.frameReady || state.userPaused || state.permissionBlocked) return;
            if (video.paused) return;
            advanceSource();
          }, 8000);
        };
        const playRejected = (error, attempt) => {
          if (!current() || attempt !== state.attempt) return;
          if (error?.name === 'AbortError') return;
          if (error?.name === 'NotAllowedError') {
            state.permissionBlocked = true;
            clearWatchdog();
            return;
          }
          if (error?.name === 'NotSupportedError' || [2, 3, 4].includes(video.error?.code)) advanceSource();
        };
        const advanceSource = () => {
          clearWatchdog();
          if (!current() || state.userPaused || state.permissionBlocked || state.exhausted) return;
          if (state.index + 1 >= sources.length) {
            state.exhausted = true;
            return;
          }
          if (Number.isFinite(video.currentTime) && video.currentTime >= 0 && (video.readyState >= 1 || video.currentTime > 0)) state.resumeTime = video.currentTime;
          state.index++;
          state.attempt++;
          state.frameReady = false;
          const attempt = state.attempt;
          video.src = sources[state.index].url;
          video.preload = 'metadata';
          try {
            // load() must precede play() in the same activation; it would otherwise abort pending play.
            video.load();
            if (!current() || attempt !== state.attempt) return;
            watchStartup(attempt);
            const playback = video.play();
            if (playback && typeof playback.catch === 'function') playback.catch(error => playRejected(error, attempt));
          } catch (error) {
            playRejected(error, attempt);
          }
        };
        video.addEventListener('loadedmetadata', () => {
          if (!current() || !state.resumeTime) return;
          try {
            const duration = Number.isFinite(video.duration) ? video.duration : state.resumeTime;
            video.currentTime = Math.min(state.resumeTime, duration);
          } catch (error) {
            // Retain native controls if this browser cannot seek until more data arrives.
          }
        }, options);
        video.addEventListener('loadeddata', () => {
          if (video.readyState >= 2) stopStartup();
        }, options);
        video.addEventListener('playing', stopStartup, options);
        video.addEventListener('pause', () => {
          // A queued pause from load() must not be mistaken for a user pause after play() restarts it.
          if (!current() || !video.paused || video.error) return;
          state.userPaused = true;
          clearWatchdog();
        }, options);
        video.addEventListener('play', () => {
          if (!current() || video.paused) return;
          state.userPaused = false;
          state.permissionBlocked = false;
          watchStartup(state.attempt);
        }, options);
        video.addEventListener('error', () => {
          if (current() && [2, 3, 4].includes(video.error?.code)) advanceSource();
        }, options);
        advanceSource();
      }
      _clearMobileStartup() {
        const state = this.mobilePlayback;
        this.mobilePlayback = null;
        if (!state) return;
        if (state.timer !== null) clearTimeout(state.timer);
        state.timer = null;
        state.controller.abort();
      }
      play() {}
      pause() {
        if (this.dialog?.open) this.dialog.close();
        this.reset();
      }
      reset() {
        this._clearMobileStartup();
        const wasActive = this.playbackActive;
        this.playbackActive = false;
        this.inlineActive = false;
        this.player?.querySelectorAll('video').forEach(video => video.pause());
        this.player?.replaceChildren();
        this.inlinePlayer?.querySelectorAll('video').forEach(video => video.pause());
        this.inlinePlayer?.replaceChildren();
        if (this.inlinePlayer) this.inlinePlayer.hidden = true;
        if (this.trigger) this.trigger.hidden = false;
        this.trigger?.setAttribute('aria-expanded', 'false');
        if (wasActive) this.dispatchEvent(new CustomEvent('video:paused', { bubbles: true }));
        if (!document.querySelector('.feelits-product-video__dialog[open]')) document.documentElement.classList.remove('feelits-video-open');
      }
      disconnectedCallback() {
        this.pause();
        this.events?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
